import { render, staticRenderFns } from "./RegisterOfPaymentsToolbar.vue?vue&type=template&id=085ca4ba&"
import script from "./RegisterOfPaymentsToolbar.vue?vue&type=script&lang=js&"
export * from "./RegisterOfPaymentsToolbar.vue?vue&type=script&lang=js&"
import style0 from "./RegisterOfPaymentsToolbar.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports